import { render, staticRenderFns } from "./TaxClassificationMaintain.vue?vue&type=template&id=dfa9c684&"
import script from "./TaxClassificationMaintain.vue?vue&type=script&lang=js&"
export * from "./TaxClassificationMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa9c684')) {
      api.createRecord('dfa9c684', component.options)
    } else {
      api.reload('dfa9c684', component.options)
    }
    module.hot.accept("./TaxClassificationMaintain.vue?vue&type=template&id=dfa9c684&", function () {
      api.rerender('dfa9c684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/TaxClassificationMaintain.vue"
export default component.exports